import type { PlatformUrls } from '@/types';

/** Canonical list of valid platform keys — used for validation and filtering. */
export const VALID_PLATFORM_KEYS: (keyof PlatformUrls)[] = ['linkedin', 'x', 'facebook'];

/**
 * Maps between frontend platform keys and backend platform keys.
 * Currently aligned — kept as a translation seam for future migrations.
 */
const BACKEND_TO_FRONTEND: Record<string, string> = {};
const FRONTEND_TO_BACKEND: Record<string, string> = {};

/** Convert a backend platform key to the frontend equivalent. */
export function toFrontendKey(backendKey: string): string {
  const k = backendKey.toLowerCase();
  return BACKEND_TO_FRONTEND[k] ?? k;
}

/** Convert a frontend platform key to the backend equivalent. */
export function toBackendKey(frontendKey: string): string {
  const k = frontendKey.toLowerCase();
  return FRONTEND_TO_BACKEND[k] ?? k;
}
